import { Select } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { TodoStatus } from "../../../../utils/backend-types";
import type { TodoTableTodo } from "../TodoTable";

function getStatusColumn(
  onChangeStatus: (newStatus: TodoStatus, todoId: number) => void,
  areSomeTodosNotRelevant: boolean = false
): MRT_ColumnDef<TodoTableTodo> {
  return {
    header: "Status",
    accessorKey: "status",
    size: 140,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: areSomeTodosNotRelevant
        ? [
            { value: TodoStatus.Open, label: "Offen" },
            { value: TodoStatus.Done, label: "Erledigt" },
            { value: TodoStatus.NotRelevant, label: "Nicht relevant" }
          ]
        : [
            { value: TodoStatus.Open, label: "Offen" },
            { value: TodoStatus.Done, label: "Erledigt" }
          ]
    },
    Cell: ({ row }) => (
      <Select
        data={[
          { value: TodoStatus.Open, label: "Offen" },
          { value: TodoStatus.Done, label: "Erledigt" }
        ]}
        value={row.original.status}
        onChange={(newStatus) =>
          onChangeStatus(newStatus as TodoStatus, row.original.id)
        }
      />
    )
  };
}

export { getStatusColumn };
